import Image from "next/image";
import { ChangeEvent, useState } from "react";

interface Props {
  value?: string;
  onChange?: (ev: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  name?: string;
  id?: string;
  className?: string;
}

/**
 * 汎用パスワード入力
 */
export default function InputPassword({
  id,
  value,
  name,
  onChange,
  placeholder,
  className,
  ...other
}: Props) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="flex relative">
      <input
        className={`p-2 pr-8 w-full border border-neutral-500 ${
          className ?? ""
        }`}
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        name={name}
        id={id}
        {...other}
      />
      <button
        type="button"
        className="flex absolute top-0 right-0 items-center p-1 h-full"
        onClick={() => setShowPassword(!showPassword)}
        tabIndex={-1}
      >
        <Image
          src={
            showPassword
              ? "/customer/icon/eye_enable.svg"
              : "/customer/icon/eye_disable.svg"
          }
          alt=""
          width={24}
          height={24}
        />
      </button>
    </div>
  );
}
